export default {
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:8080',
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
};
